import { render, staticRenderFns } from "./CuentaTablaRegistro.vue?vue&type=template&id=8c468742&"
import script from "./CuentaTablaRegistro.vue?vue&type=script&lang=js&"
export * from "./CuentaTablaRegistro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports